import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AgGridModule } from '@ag-grid-community/angular';
import { PageTitleModule } from 'app/layout/components/page-title/page-title.module';
import { CubeComponent } from 'app/main/cube/cube.component';
import { MaterialModule } from 'app/main/material.module';
import { MomentModule } from 'ngx-moment';
import { CubeEffects } from './cube.effects';
import * as fromCube from './cube.reducer';
import { CubeResolver } from './cube.resolver';
import { CubeDetailModule } from './cube-detail/cube-detail.module';

@NgModule({
    declarations: [CubeComponent],
    imports: [
        FuseSharedModule,
        MaterialModule,
        PageTitleModule,
        CubeDetailModule,
        
        // AG Grid
        AgGridModule.withComponents([]),

        MomentModule,
        StoreModule.forFeature('cube', fromCube.reducer),
        EffectsModule.forFeature([CubeEffects])
    ],
    exports: [CubeComponent],
    providers: [CubeResolver]
})
export class CubeModule {}
